import formatMoney from '../formatMoney';

const PLACEHOLDER_COUNT = '88888888';

const formatCartSubtotalLabel = (lineCount) => {
  const s = window.theme?.strings;
  if (!s?.cartSubtotalPrefix) return '';
  const inner =
    lineCount === 1
      ? s.cartSubtotalItemsOne || ''
      : (s.cartSubtotalItemsOtherTpl || '').split(PLACEHOLDER_COUNT).join(String(lineCount));
  return `${s.cartSubtotalPrefix} (${inner})`;
};

const updateCartSubtotalPreview = ({
  pricingMap,
  variantId,
  labelEl,
  mainEl,
  plusEl,
  addonEl,
  equalsEl,
  totalEl
}) => {
  if (!labelEl || !totalEl || !pricingMap) return;

  const row = pricingMap[String(variantId)];
  if (!row) return;

  const { lineCount, main, addon, total, addonCompareAt = 0 } = row;
  const moneyFmt = window.theme?.moneyFormat;
  const twoLine = lineCount > 1;
  const showAddonCompareAt = twoLine && addon === 0 && addonCompareAt > 0;

  labelEl.textContent = formatCartSubtotalLabel(lineCount);

  plusEl?.classList.toggle('hidden', !twoLine);
  addonEl?.classList.toggle('hidden', !twoLine);
  equalsEl?.classList.toggle('hidden', !twoLine);
  mainEl?.classList.toggle('hidden', !twoLine);

  totalEl.textContent = formatMoney(total, moneyFmt);
  if (twoLine && mainEl && addonEl) {
    mainEl.textContent = formatMoney(main, moneyFmt);
    addonEl.textContent = formatMoney(showAddonCompareAt ? addonCompareAt : addon, moneyFmt);
    addonEl.classList.toggle('line-through', showAddonCompareAt);
    addonEl.classList.toggle('decoration-1', showAddonCompareAt);
  }
};

export default updateCartSubtotalPreview;
